import axios from "axios";

import { Me } from "./users";
import { PostGet } from "./post";
import { MainUrl } from "../constants";

const API_URL = `${MainUrl}`;

export const login = async (username, password) => {
  const params = new URLSearchParams();
  params.append("username", username);
  params.append("password", password);

  const response = await axios.post(`${API_URL}/auth/jwt/login`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  const user = await Me(response.data.access_token);

  const post_id = user.post_id;
  const post = await PostGet(response.data.access_token, post_id);

  const access_level = post.access_level;
  return {
    access_token: response.data.access_token,
    access_level: access_level,
  };
};

export const getProfile = async (token) => {
  const response = await axios.get(`${API_URL}/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
